/**
 * Form di accesso.
 *
 * Sostituisce il login da console del browser usato finora per provare la
 * fetta verticale del timer. Stessa rotta API di sempre (`POST /api/accesso`),
 * solo con un'interfaccia davanti.
 */

import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { chiama, ErroreApi } from '../api/client.js';
import './accesso.css';

export function PaginaAccesso({ onAccesso }: { onAccesso: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [invio, setInvio] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  const [parametri] = useSearchParams();

  const invia = async (e: FormEvent) => {
    e.preventDefault();
    setInvio(true);
    setErrore(null);
    try {
      await chiama('/accesso', { metodo: 'POST', corpo: { email, password } });
      onAccesso();
    } catch (err) {
      setErrore(
        err instanceof ErroreApi && err.stato === 401
          ? 'Email o password non corretti.'
          : 'Accesso non riuscito. Riprova.',
      );
    } finally {
      setInvio(false);
    }
  };

  return (
    <div className="accesso">
      <form className="accesso-scheda" onSubmit={(e) => void invia(e)}>
        <h1>Accedi</h1>

        {parametri.get('password') === 'aggiornata' && !errore && (
          <div className="accesso-conferma" role="status">
            Password aggiornata: accedi con quella nuova.
          </div>
        )}

        {errore && (
          <div className="banda" role="alert">
            {errore}
          </div>
        )}

        <label className="campo">
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>

        <label className="campo">
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button type="submit" disabled={invio}>
          {invio ? 'Accesso in corso…' : 'Accedi'}
        </button>

        <Link to="/password-dimenticata" className="accesso-link">
          Password dimenticata?
        </Link>
      </form>
    </div>
  );
}
